(function () {
  'use strict';

  function portalToBody(el) {
    if (el && el.parentNode !== document.body) {
      document.body.appendChild(el);
    }
  }

  function initPdpGallery() {
    portalToBody(document.querySelector('[data-pdp-lightbox]'));
    portalToBody(document.querySelector('[data-pdp-model-overlay]'));

    var form = document.getElementById('AddToCartForm');
    if (!form) return;

    var productDataEl = document.getElementById('pdp-product-data');
    if (!productDataEl) return;

    var product;
    try {
      product = JSON.parse(productDataEl.textContent);
    } catch (e) {
      return;
    }

    var hiddenId = document.getElementById('VariantId');
    var optionInputs = form.querySelectorAll('input[data-option-index]');
    var regularPriceEl = form.querySelector('[data-regular-price]');
    var priceNoVatEl = form.querySelector('[data-price-no-vat]');
    var addToCartBtn = form.querySelector('[data-add-to-cart]');
    var addToCartText = document.getElementById('AddToCartText');
    var heroImg = document.querySelector('[data-pdp-hero-img]');
    var selectedColorEl = document.querySelector('[data-selected-color]');
    var selectedColorWrap = document.querySelector('[data-selected-color-wrap]');
    var mediaJsonEl = document.querySelector('[data-pdp-media]');
    var mediaById = {};

    if (mediaJsonEl) {
      try {
        var mediaList = JSON.parse(mediaJsonEl.textContent);
        mediaList.forEach(function (m) {
          mediaById[String(m.id)] = m;
        });
      } catch (e) { /* ignore */ }
    }

    function getSelectedOptions() {
      var opts = [];
      product.options.forEach(function (_, i) {
        var input = form.querySelector('input[data-option-index="' + i + '"]:checked');
        opts.push(input ? input.value : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return (v.option1 || null) === opts[0] &&
          (v.option2 || null) === opts[1] &&
          (v.option3 || null) === opts[2];
      });
    }

    function findVariantFromInput(input) {
      var variantId = input.getAttribute('data-variant-id');
      if (variantId) {
        var byId = product.variants.find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (byId) return byId;
      }
      return findVariant(getSelectedOptions());
    }

    function formatMoney(cents) {
      if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.moneyFormat);
      }
      return (cents / 100).toFixed(2);
    }

    function removeVat(cents) {
      return Math.round(cents / 1.2);
    }

    function getVariantMediaId(variant) {
      if (!variant) return null;
      if (variant.featured_media && variant.featured_media.id) {
        return variant.featured_media.id;
      }
      if (variant.featured_image && variant.featured_image.id) {
        return variant.featured_image.id;
      }
      return null;
    }

    function updateHero(variant, input) {
      if (!heroImg) return;

      var mediaId = null;
      if (input) {
        mediaId = input.getAttribute('data-featured-media-id');
      }
      if (!mediaId) {
        mediaId = getVariantMediaId(variant);
      }
      if (!mediaId && !variant) return;

      var media = mediaId ? mediaById[String(mediaId)] : null;
      if (!media && variant && variant.featured_image && variant.featured_image.src) {
        heroImg.src = variant.featured_image.src;
        heroImg.alt = variant.featured_image.alt || '';
        if (mediaId) heroImg.setAttribute('data-featured-media-id', mediaId);
        return;
      }
      if (!media) return;

      heroImg.src = media.src;
      heroImg.alt = media.alt || '';
      heroImg.width = media.width;
      heroImg.height = media.height;
      heroImg.setAttribute('data-featured-media-id', mediaId);
    }

    function getColorOptionIndex() {
      return product.options.findIndex(function (name) {
        var lower = (name || '').toLowerCase();
        return lower === 'color' || lower === 'colour';
      });
    }

    function getSelectedColorName(variant, input) {
      var colorIndex = getColorOptionIndex();
      if (input && colorIndex >= 0) {
        var inputIndex = parseInt(input.getAttribute('data-option-index'), 10);
        if (inputIndex === colorIndex) {
          return input.getAttribute('data-option-value') || '';
        }
      }
      if (!variant) return '';
      if (colorIndex === 0) return variant.option1 || '';
      if (colorIndex === 1) return variant.option2 || '';
      if (colorIndex === 2) return variant.option3 || '';
      return variant.title || '';
    }

    function updateSelectedColor(variant, input) {
      if (!selectedColorEl) return;
      var name = getSelectedColorName(variant, input);
      selectedColorEl.textContent = name;
      if (selectedColorWrap) {
        selectedColorWrap.hidden = !name;
        selectedColorWrap.setAttribute('aria-hidden', name ? 'false' : 'true');
      }
      selectedColorEl.hidden = !name;
      selectedColorEl.setAttribute('aria-hidden', name ? 'false' : 'true');
    }

    function updateUI(variant, input) {
      var addToCartLabel = form.getAttribute('data-add-to-cart-text') || 'Add to cart';
      var soldOutLabel = form.getAttribute('data-sold-out-text') || 'Sold out';
      var unavailableLabel = form.getAttribute('data-unavailable-text') || 'Unavailable';

      if (!variant) {
        if (addToCartBtn) addToCartBtn.disabled = true;
        if (addToCartText) addToCartText.textContent = unavailableLabel;
        return;
      }

      if (hiddenId) hiddenId.value = variant.id;
      if (regularPriceEl) regularPriceEl.innerHTML = formatMoney(variant.price);
      if (priceNoVatEl) priceNoVatEl.innerHTML = formatMoney(removeVat(variant.price));
      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        if (addToCartText) {
          addToCartText.textContent = variant.available ? addToCartLabel : soldOutLabel;
        }
      }
      updateHero(variant, input);
      updateSelectedColor(variant, input);
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var variant = findVariantFromInput(input);
        updateUI(variant, input);
      });
    });

    var initialVariant = product.variants.find(function (v) {
      return v.id === (hiddenId ? parseInt(hiddenId.value, 10) : null);
    }) || product.variants[0];

    var initialInput = form.querySelector('input[data-option-index]:checked');
    updateUI(initialVariant, initialInput);

    initLightbox(mediaById);
    initModelOverlay();
  }

  function initLightbox(mediaById) {
    var trigger = document.querySelector('[data-pdp-lightbox-trigger]');
    var overlay = document.querySelector('[data-pdp-lightbox]');
    var lightboxImg = document.querySelector('[data-pdp-lightbox-img]');
    var heroImg = document.querySelector('[data-pdp-hero-img]');
    if (!trigger || !overlay || !lightboxImg || !heroImg) return;

    function openLightbox() {
      var mediaId = heroImg.getAttribute('data-featured-media-id');
      var media = mediaById[String(mediaId)];
      if (!media) return;
      lightboxImg.src = media.srcLarge || media.src;
      lightboxImg.alt = media.alt || '';
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', openLightbox);
    overlay.querySelectorAll('[data-pdp-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeLightbox();
    });
  }

  function initModelOverlay() {
    var openBtn = document.querySelector('[data-pdp-model-open]');
    var overlay = document.querySelector('[data-pdp-model-overlay]');
    var viewerWrap = document.querySelector('[data-pdp-model-viewer-wrap]');
    var template = document.querySelector('[data-pdp-model-template]');
    if (!openBtn || !overlay || !viewerWrap || !template) return;

    var modelLoaded = false;

    function loadModel() {
      if (modelLoaded) return;
      viewerWrap.appendChild(template.content.cloneNode(true));
      modelLoaded = true;
    }

    function openOverlay() {
      loadModel();
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeOverlay() {
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', openOverlay);
    overlay.querySelectorAll('[data-pdp-model-close]').forEach(function (el) {
      el.addEventListener('click', closeOverlay);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeOverlay();
    });
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initPdpGallery();
  } else {
    document.addEventListener('DOMContentLoaded', initPdpGallery);
  }
})();
